type RuntimeConfig = {
  REACT_APP_REST_HOST?: string;
  REACT_APP_MEDIA_HOST?: string;
  REACT_APP_GOOGLE_MAPS_API_KEY?: string;
  DRIVER_IMPORT_TEMPLATE_URL?: string;
  VENDOR_IMPORT_TEMPLATE_URL?: string;
  REACT_APP_DRIVER_IMPORT_TEMPLATE_URL?: string;
  REACT_APP_VENDOR_IMPORT_TEMPLATE_URL?: string;
  CUSTOMER_IMPORT_TEMPLATE_URL?: string;
};

const runtimeConfig: RuntimeConfig =
  typeof window !== "undefined"
    ? window.__RUNTIME_CONFIG__ ?? {}
    : {};

const getNonEmpty = (
  value?: string,
): string | undefined => {
  if (
    typeof value !==
    "string"
  ) {
    return undefined;
  }

  return value.trim() === ""
    ? undefined
    : value;
};

const readEnv = (
  key: keyof RuntimeConfig,
): string => {
  return (
    getNonEmpty(
      runtimeConfig[key],
    ) ??
    getNonEmpty(
      process.env[key],
    ) ??
    ""
  );
};

export const env = {
  REST_HOST: readEnv(
    "REACT_APP_REST_HOST",
  ),

  MEDIA_HOST: readEnv(
    "REACT_APP_MEDIA_HOST",
  ),

  GOOGLE_MAPS_API_KEY:
    readEnv(
      "REACT_APP_GOOGLE_MAPS_API_KEY",
    ),

  DRIVER_IMPORT_TEMPLATE_URL:
    readEnv("DRIVER_IMPORT_TEMPLATE_URL") ||
    readEnv("REACT_APP_DRIVER_IMPORT_TEMPLATE_URL"),

  VENDOR_IMPORT_TEMPLATE_URL:
    readEnv("VENDOR_IMPORT_TEMPLATE_URL") ||
    readEnv("REACT_APP_VENDOR_IMPORT_TEMPLATE_URL"),
  CUSTOMER_IMPORT_TEMPLATE_URL:
    readEnv("CUSTOMER_IMPORT_TEMPLATE_URL"),
};